import { useEffect, useState } from "react";

import { supabase } from "~/integrations/supabase/client";
import { Address } from "~/types/client";
import { createPickupAddress, isPickupAddress } from "~/utils/addressUtils";

export const useAddressSelection = (initialAddressId: string | null = null) => {
  const [selectedAddressId, setSelectedAddressId] = useState<string | null>(
    initialAddressId
  );
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  // Fetch selected address details when addressId changes
  useEffect(() => {
    const fetchAddressDetails = async () => {
      if (!selectedAddressId) {
        setSelectedAddress(null);
        return;
      }

      // Handle pickup option
      if (isPickupAddress(selectedAddressId)) {
        const pickupAddress = createPickupAddress("pickup");
        setSelectedAddress(pickupAddress);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("addresses")
          .select("*")
          .eq("id", selectedAddressId)
          .single();

        if (error) throw error;

        setSelectedAddress({
          id: data.id,
          clientId: data.client_id,
          street: data.street,
          number: data.number,
          complement: data.complement || undefined,
          city: data.city,
          state: data.state || undefined,
          comuna: data.comuna || undefined,
          isDefault: data.is_default || false,
          createdAt: data.created_at,
          updatedAt: data.updated_at,
        });
      } catch (error) {
        console.error("Error fetching address details:", error);
        setSelectedAddress(null);
      }
    };

    fetchAddressDetails();
  }, [selectedAddressId]);

  return {
    selectedAddressId,
    setSelectedAddressId,
    selectedAddress,
  };
};
